import * as yup from 'yup';

export const validationSchema = yup.object({
    eToll: yup.object({
        enabled: yup.boolean().default(false),
    }),
});
